<template>
  <div class="flex flex-wrap items-center rounded cursor-pointer" @click="$emit('open')">
    <div class="w-8 flex items-center justify-center">
      <icon class="text-xl" icon="file"/>
    </div>
    <div class="flex-1 items-center break-all">
      <input ref="name"
             spellcheck="false"
             v-model="name"
             class="w-full px-1 border-1 bg-transparent"
             :class="editName ? 'text-input' : 'pointer-events-none'"
             @keypress.enter="rename"
             @blur="rename"
      />
    </div>
  </div>
</template>

<script>
import attributeMixins from '@/mixins/attribute'
export default {
  mixins: [attributeMixins],
  props: ['attribute']
}
</script>

<style scoped lang="scss">
  .name {
    box-sizing: border-box;
  }
</style>
